import { TokenService } from "@/services/TokenService";
import Token from '@/_models/Token';
// import { Helper } from "@/utils/Helper";
export class TokenUtils{
  async getWalletAddressToken (address:string):Promise<Token[]> {
    try{
      const tokenService = new TokenService();
      const tokens = await tokenService.getTokenListByWalletAddress(address);
      return tokens;
    }catch(err){
      // error handlign not need as it is loaded together with profile endpoint
      // Helper.endpointErrorHandling(err);
      console.error(err);
    }
  }
}